export default __webpack_public_path__ + "static/media/bucket.8d42d9e6.svg";